import { z } from "zod";
import { slugString } from "./slug.js";

// An athlete's own timer for one exercise (#411): the rest after a set and the
// hold a timed set counts down from. It lives in the athlete's partition, never
// on the catalog row, because the catalog is shared: a timer written there was
// everyone's (Antenore's gear set Leonardo's and Erika's rests). The resolution
// stays athlete, then profile, then the fallback (restTimer.ts); the exercise
// list (GET /api/exercises) lays these rows over the catalog it returns, so the
// readers keep reading Exercise.defaultRestSec / defaultDurationSec.
//
// Stored pk=USER#<sub>, sk=EXTIMER#<exerciseSlug>: one row per exercise, keyed
// by the slug like Bookmark, so a re-save is an idempotent overwrite and a clear
// is a direct-key delete. A row with neither field is not kept: the route
// deletes it instead.

export const ExerciseTimer = z.object({
  exerciseSlug: slugString(64),
  // Same bounds as Exercise.defaultRestSec and Exercise.defaultDurationSec.
  restSec: z.number().int().min(0).max(600).optional(),
  holdSec: z.number().int().min(0).max(3600).optional(),
  updatedAt: z.iso.datetime(),
});
export type ExerciseTimer = z.infer<typeof ExerciseTimer>;

// Client → server body of PUT /api/me/exercise-timers/<slug>. The slug is the
// path; the server stamps updatedAt. Both fields absent = delete the row.
export const ExerciseTimerBody = ExerciseTimer.pick({
  restSec: true,
  holdSec: true,
}).strict();
export type ExerciseTimerBody = z.infer<typeof ExerciseTimerBody>;
